import request from "@/utils/request";

/**
 * 用户登录
 * @param {Object} data - 登录数据
 * @param {string} data.email - 邮箱
 * @param {string} data.password - 密码
 * @returns {Promise} 登录结果
 */
export const login = (data) => {
    return request({
        url: "/api/user/login",
        method: "POST",
        data,
    });
};

/**
 * 用户注册
 * @param {Object} data - 注册数据
 * @param {string} data.email - 邮箱
 * @param {string} data.password - 密码
 * @returns {Promise} 注册结果
 */
export const register = (data) => {
    return request({
        url: "/api/user/register",
        method: "POST",
        params: {
            email: data.email,
            password: data.password,
        },
        // data
    });
};

/**
 * 用户登出
 * @returns {Promise} 登出结果
 */
export const logout = () => {
    return request({
        url: "/api/user/logout",
        method: "POST",
    });
};

/**
 * 获取当前用户角色和菜单信息
 * @returns {Promise} 用户信息
 */
export const getUserInfo = () => {
    return request({
        url: "/api/user/info",
        method: "GET",
    });
};

/**
 * 发送邮箱验证码
 * @param {string} email - 邮箱地址
 * @param {number} timeStamp - 时间戳
 * @returns {Promise} 发送结果
 */
export const sendEmailCode = (email, timeStamp) => {
    return request({
        url: "/api/user/sendEmail",
        method: "POST",
        params: {
            email,
            timeStamp,
        },
    });
};

/**
 * 验证邮箱验证码
 * @param {Object} data - 验证数据
 * @param {string} data.email - 邮箱地址
 * @param {number} data.code - 验证码
 * @returns {Promise} 验证结果
 */
export const validateEmailCode = (data) => {
    return request({
        url: "/api/user/getValidateCode",
        method: "POST",
        data: {
            email: data.email,
            code: data.code,
        },
    });
};

/**
 * 获取秘钥
 */
export const getSecretKey = () => {
    return request({
        url: "/api/user/publicKey",
        method: "GET",
    });
};

// 默认导出所有方法
export default {
    login,
    register,
    logout,
    getUserInfo,
    sendEmailCode,
    validateEmailCode,
};
